import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { FormControl } from "@mui/material";
import { useStore } from "csi/state/hooks";
import rootStore from "csi/state/rootStore";
import FlexColumn from "designSystem/components/flex/FlexColumn";
import FlexRowCenter from "designSystem/components/flex/FlexRowCenter";
import PaneHeader from "designSystem/components/pane/PaneHeader";
import { FormControlLabel, IconButton } from "designSystem/index";
import { grey } from "designSystem/styles/color";
import { observer } from "mobx-react-lite";
import React from "react";
import { GenerateImages } from "./GenerateImages";
import { SaveSnapshotPlaceholder } from "./SaveSnapshotPlaceholder";
import { SnapshotEmptyPlaceholder } from "./SnapshotEmptyPlaceholder";
import SnapshotList from "./SnapshotList";
import SnapshotListFilters from "./SnapshotListFilters";

export const PREFIX = "ThreeDSnapshot";

const HEADER_STYLES = {
	justifyContent: "space-between",
	"& .MuiTypography-body1": {
		fontSize: "16px",
		fontWeight: 600,
		lineHeight: "18px",
	},
};

const ThreeDSnapshot = observer(() => {
	const { rightPaneStore } = useStore();
	const { closeSelected } = rightPaneStore;
	const { threeDStore: { snapshotsStore, modelViewerStore } } = rootStore;
	const { snapshotsData, generateImagesPageOpen, toggleGenerateImagesPage } = snapshotsStore;

	return (
		!generateImagesPageOpen ? (
			<FlexColumn>
				<PaneHeader
					onClose={closeSelected}
					titleRes="3DCapturedSnap"
				/>
				{ !!modelViewerStore && (
					<>
						<FlexRowCenter
							bgcolor={grey[100]}
							p={3}
						>
							<FormControl fullWidth>
								<FormControlLabel
									block
									control={(
										<IconButton
											color="inherit"
											onClick={toggleGenerateImagesPage}
											size="large"
										>
											<ArrowForwardIosIcon />
										</IconButton>
									)}
									labelPlacement="start"
									res="GenerateImages"
									sx={HEADER_STYLES}
								/>
							</FormControl>
						</FlexRowCenter>
						{ snapshotsData.length > 0 ? (
							<>
								<SnapshotListFilters />
								<SnapshotList />
							</>
						): (
							<SnapshotEmptyPlaceholder />
						)}
						<SaveSnapshotPlaceholder />
					</>
				)}
			</FlexColumn>
		) : (
			<GenerateImages />
		)
	);
});

export default ThreeDSnapshot;